import {
  axiosGetWithCookies,
  axiosPostWithCookies,
  axiosPutWithCookies,
  axiosPatchWithCookies,
} from './helper';

export const fetchUserList = ({
  securityCompanyId,
  roles = [],
  archived = false,
  businessClientId,
  service,
  status,
  search,
  from,
  limit = 50,
  departmentId,
  siteId,
}) => {
  let query = `limit=${limit}`; //limit is always sent so put it first.
  if (roles && Array.isArray(roles)) {
    /* eslint-disable no-param-reassign */
    query += roles.reduce((acc, r) => `${acc}&role=${r}`, '');
  }
  if (departmentId === 'EMPTY_DEPARTMENT') {
    query += `&departmentId=${''}`;
  } else if (departmentId) {
    query += `&departmentId=${departmentId}`;
  }
  if (status && Array.isArray(status)) {
    /* eslint-disable no-param-reassign */
    query += status.reduce((acc, s) => `${acc}&status=${s}`, '');
  }
  if (from) query += `&from=${from}`;
  if (securityCompanyId) query += `&securityCompanyId=${securityCompanyId}`;
  if (archived) query += `&includeArchived=${archived}`;
  if (typeof businessClientId === 'object') {
    query += `&businessClientId=${businessClientId?.id}`;
  } else if (businessClientId) {
    query += `&businessClientId=${businessClientId}`;
  }
  if (service && Array.isArray(service)) {
    /* eslint-disable no-param-reassign */
    query += service.reduce((acc, s) => `${acc}&service=${s}`, '');
  }
  if (search) query += `&search=${search}`;
  if (siteId) query += `&siteId=${siteId}`;

  return axiosGetWithCookies(`/users/users?${query}`);
};

export const fetchUserDetail = id => axiosGetWithCookies(`/users/users/${id}`);

export const addUser = user =>
  axiosPostWithCookies(`/users/users`, {
    data: user,
  });

export const updateUser = (id, user) =>
  axiosPutWithCookies(`/users/users/${id}`, {
    data: user,
  });

export const updatePasscode = (id, passcode) =>
  axiosPatchWithCookies(`/users/users/${id}/passcode`, {
    data: passcode,
  });

export const fetchPersonnelTemplateCSV = () =>
  axiosGetWithCookies(`/users/users/import/csv/template`);

export const uploadPersonnelCSV = personnelDoc =>
  axiosPostWithCookies(`/users/users/import/csv`, personnelDoc);
